import {Divider, Menu, MenuItem} from "@mui/material";
import ArchiveIcon from "@mui/icons-material/Archive";
import * as React from "react";
import {useDeleteTemplateMutation, useDuplicateTemplateMutation} from "../../../../services/templates";
import {toast} from "react-toastify";
import {useNavigate} from 'react-router-dom';

interface TemplateRightMenuProps {
  menuAnchor: HTMLElement | null;
  closeMenu: () => void;
  menuForId: string | null;
}

export default function TemplateRightMenu(
  {
    menuAnchor,
    closeMenu,
    menuForId,
  }: TemplateRightMenuProps
) {
  const navigate = useNavigate();
  const [deleteTemplateApi] = useDeleteTemplateMutation();
  const [duplicateTemplateApi] = useDuplicateTemplateMutation();
  const onDeleteTemplate = async (id: string | null) => {
    try {
      if (!id) {
        return;
      }
      console.log("deleting template id:" + id);
      await deleteTemplateApi(id).unwrap();
    } catch (e) {
      toast(`delete failed id:${id} error: ${e}`);
    }
  }
  const onDuplicateTemplate = async (id: string | null) => {
    try {
      if (!id) {
        return;
      }
      console.log("duplicate template template id:" + id);
      // create a copy for temlate (template Id) => swtich to edit
      var response = await duplicateTemplateApi({id}).unwrap();
      var templateId = response.id;

      // nativate to this URL
      navigate(`/templates/${templateId}/edit`);

    } catch (e) {
      toast(`duplicate failed id:${id} error: ${e}`);
    }
  }
  return (
    <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={closeMenu}>
      <MenuItem onClick={() => {
        console.log('duplicate', menuForId);
        onDuplicateTemplate(menuForId);
        closeMenu();
      }}>
        Duplicate
      </MenuItem>

      <MenuItem onClick={() => {
        console.log('enable', menuForId);
        closeMenu();
      }}>
        Enable
      </MenuItem>

      <MenuItem onClick={() => {
        console.log('archive', menuForId);
        closeMenu();
      }}>
        Archive
      </MenuItem>

      <Divider component="li" sx={{my: 0.5}}/>
      <MenuItem onClick={() => {
        onDeleteTemplate(menuForId);
        closeMenu();
      }}
                sx={{color: "error.main"}}><ArchiveIcon fontSize="small"
                                                        style={{marginRight: 8}}/> Delete</MenuItem>

    </Menu>

  )
}